import ApiService from '../index'

const qs = require('qs')

export const documentation = async (query) => {
  const URIDocumentation = `/api/document?${qs.stringify(query)}`
  const URIStatus = `/api/statusDocument?${qs.stringify(query)}`

  const response = await Promise.all([
    ApiService.get(URIDocumentation),
    ApiService.get(URIStatus)
  ])

  const documentation = response[0].data.map((line) => {
    line.hover = false
    return line
  })

  return {
    documentation,
    status: response[1].data[0]
  }
}

export const addDocument = async (document) => {
  const URI = `/api/document`

  const response = await ApiService.post(URI, document)

  return response.data
}

export const updateDocument = async (document) => {
  const URI = `/api/document/${document.id}`

  const response = await ApiService.patch(URI, document)

  return response.data
}

export const logsDocumentation = async (id, minDate = '', maxDate = '', changedDate = '') => {
  const URI = `/api/audit?product_id=${id}&product=documents&min_date=${minDate}&max_date=${maxDate}&changed_date=${changedDate}`

  const response = await ApiService.get(URI)

  return response.data
}

// export const toggleStatus = async (id) => {
//   const URI = `/api/user/desative/${id}`

//   const response = await ApiService.post(URI, {})

//   return response
// }

// export const deleteUser = async (id) => {
//   const URI = `/api/user/${id}`

//   const response = await ApiService.delete(URI)

//   return response
// }

// USER FORM

// mounted () {
//   this.getComdominiums()
//   this.getProfiles()
// },
